import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { loader } from "../../../loader";
import { toast } from "react-toastify";
import { popup_alert } from "../../../popup_alert";
import { toPng } from "html-to-image";
import { Placeholder } from "react-bootstrap";
import html2canvas from "html2canvas";

export default function VerifyVwdEmail() {
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const navigate = useNavigate();
  const location = useLocation();
  const {
    userList,
    isInternal,
    emailDescription: stateDesc,
    emailSubject: stateSub,
    selectedClinicalTopic: stateClinical,
    selectedFunctionTopic: stateFunctional,
    emailState,
  } = location.state || {};

  // Extract from emailState if available (passed from CreateVwdEmail)
  const emailDescription = emailState?.emailDescription || stateDesc || "";
  const emailSubject = emailState?.emailSubject || stateSub || "";
  const selectedClinicalTopic =
    emailState?.selectedClinicalTopic || stateClinical || [];
  const selectedFunctionTopic =
    emailState?.selectedFunctionTopic || stateFunctional || [];
  const emailContent = emailState?.emailContent || "";
  const selectedTemplateId = emailState?.selectedTemplateId || null;
  const templateName = emailState?.templateName || "";
  const [templateUrl, setTemplateUrl] = useState(null);
  const [url, setUrl] = useState(null);
  const hiddenEmailRef = React.useRef(null);
  useEffect(() => {
    const convertToPng = async () => {
      if (hiddenEmailRef.current) {
        try {
          const tableElement = hiddenEmailRef.current.querySelector('table');
          let targetElement = tableElement ? tableElement.firstElementChild : hiddenEmailRef.current;
          targetElement = targetElement.querySelector('table');
          const images = targetElement.querySelectorAll('img');
          images.forEach(img => {
            if (img.src.startsWith('http')) {
              const url = new URL(img.src);
              url.searchParams.set('t', Date.now());
              img.src = url.toString();
              img.setAttribute('crossorigin', 'anonymous'); 
            }
          });

          await Promise.all(
            Array.from(images).map(img => {
              if (img.complete) return Promise.resolve();
              return new Promise(resolve => { 
                img.onload = resolve; 
                img.onerror = resolve; 
              });
            })
          );

          setTimeout(async () => {
            const canvas = await html2canvas(targetElement, {
              useCORS: true,
              scale: 2,
              allowTaint: false,
              logging: true, // Keep this true while debugging CORS
              backgroundColor: "#ffffff",
            });
            const dataUrl = canvas.toDataURL("image/png");
            setTemplateUrl(dataUrl);
          }, 500);
        } catch (err) {
          console.error("Capture failed:", err);
        }
      }
    };
    // const convertToPng = async () => {
    //   try {
    //     const canvas = await html2canvas(hiddenEmailRef.current.querySelector(), {
    //       useCORS: true,
    //       allowTaint: false,
    //       scale: 2,
    //       logging: false,
    //       backgroundColor: null,
    //       scrollX: 0,
    //       scrollY: -window.scrollY,
    //     });
    //     // const url = await toPng(hiddenEmailRef.current)
    //     // console.log(url)
    //     const tempUrl = canvas.toDataURL("image/png");
    //     setTemplateUrl(tempUrl);
    //   } catch (err) {
    //     console.error("Oops, conversion failed:", err);
    //   }
    // };
    if (hiddenEmailRef.current) {
      convertToPng();
    }
  }, [hiddenEmailRef]);

  const handleBackClick = useCallback(
    (e) => {
      e.preventDefault();
      navigate("/vwd/create-email", {
        state: {
          userList,
          isInternal,
          emailState: {
            emailDescription,
            emailSubject,
            selectedClinicalTopic,
            selectedFunctionTopic,
            emailContent,
            selectedTemplateId,
            templateName,
          },
        },
      });
    },
    [
      navigate,
      userList,
      isInternal,
      emailDescription,
      emailSubject,
      selectedClinicalTopic,
      selectedFunctionTopic,
      emailContent,
      selectedTemplateId,
      templateName,
    ],
  );

  const handleCancelClick = useCallback(
    (e) => {
      e.preventDefault();
      navigate("/vwd/profile", { replace: true });
    },
    [navigate],
  );

  const handleSendEmail = useCallback(async () => {
    try {
      loader("show");
      const finalTags = [...selectedClinicalTopic, ...selectedFunctionTopic];
      const user_details =
        userList?.map((user) => ({
          name: user.name,
          email: user.email,
          type: isInternal ? "Internal" : "External",
        })) || [];

      const body = {
        user_id: "FOkB/AUT2wGXRv ablqvbg==" || "rjiGlqA9DXJVH7bDDTX0Lg==",
        route_location: "vwd/verify-email",
        pdf_id: "16",
        subject: emailSubject || "Invitation from VWD",
        description: emailDescription || "Invitation email template vwd",
        creator: "Vwd Email",
        campaign_name: "Invitation Email",
        tags: finalTags,
        template_source_code: emailContent,
        campaign_id: "",
        campaign_data: {
          user_list: user_details,
          template_id: selectedTemplateId || 0,
          list_selection: 2,
          sublink_id: 0,
          survey_id: 0,
        },
      };

      // Set base URL for the email API
      axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
      const response = await axios.post("emailapi/send_email_new", body);

      loader("hide");
      if (response.data.status_code === 200) {
        popup_alert({
          visible: "show",
          message: response.data.message || "Email sent successfully!",
          type: "success",
        });
        // Navigate back to user management or dashboard after 2 seconds
        setTimeout(() => {
          navigate("/vwd/user-management");
        }, 2000);
      } else {
        toast.error(response.data.message || "Failed to send email");
      }
    } catch (err) {
      loader("hide");
      console.error("Error sending email:", err);
      toast.error("Something went wrong while sending the email.");
    }
  }, [
    navigate,
    emailSubject,
    emailDescription,
    emailContent,
    selectedClinicalTopic,
    selectedFunctionTopic,
    selectedTemplateId,
    userList,
  ]);

  return (
    <>
      <div className="col right-sidebar custom-change vwd-profile-verify-email">
        <div className="custom-container">
          <div className="row">
            <div className="page-top-nav sticky">
              <div className="row justify-content-end align-items-center">
                <div className="col-12 col-md-1">
                  <div className="header-btn-left">
                    <button
                      className="btn btn-primary btn-bordered back"
                      onClick={handleBackClick}
                    >
                      Back
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-9">
                  <ul className="tabnav-link">
                    <li className="">
                      <a href="">Add User</a>
                    </li>
                    <li className="">
                      <a href="">Create Your Email</a>
                    </li>
                    <li className="active active-main">
                      <a href="">Verify your Email</a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-2">
                  <div className="header-btn">
                    <button
                      className="btn btn-primary btn-bordered move-draft"
                      onClick={handleCancelClick}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary btn-filled next send_btn"
                      onClick={handleSendEmail}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ position: "absolute", left: "-9999px" }}>
              <div
                ref={hiddenEmailRef}
                style={{ width: "600px", backgroundColor: "white" ,}}
                dangerouslySetInnerHTML={{ __html: emailState.emailContent }}
              />
            </div>
            {/* MAIN SECTION */}
            <section className="verify_email sunshine_mail_verify">
              <div className="row">
                {/* LEFT SIDE */}
                <div className="col-12 verify-left">
                  <div className="verify-mail-box">
                    <div className="verify-email-detail">
                      <div>
                        <h4>Email Details</h4>
                        <h6>
                          <strong>Email Description | </strong>
                          {emailDescription || "-"}
                        </h6>
                        {((selectedClinicalTopic &&
                          selectedClinicalTopic.length > 0) ||
                          (selectedFunctionTopic &&
                            selectedFunctionTopic.length > 0)) && (
                          <h6>
                            <strong>Topics | </strong>
                            <ul>
                              {selectedClinicalTopic?.map((topic, index) => (
                                <li
                                  key={`clinical-${index}`}
                                  className="list1 clinical"
                                >
                                  {topic}{" "}
                                </li>
                              ))}
                              {selectedFunctionTopic?.map((topic, index) => (
                                <li key={`function-${index}`} className="list1">
                                  {topic}{" "}
                                </li>
                              ))}
                            </ul>
                          </h6>
                        )}
                      </div>
                    </div>

                    {/* RECIPIENT */}
                    <div className="mail-recipt sunshine-mail-recipt">
                      <div className="d-flex justify-content-between">
                        <div className="mail-recipt-left w-100">
                          <h6>
                            The recipients |
                            <span> {userList?.length || 0}</span>
                          </h6>
                          {userList?.map((user, index) => (
                            <div
                              key={index}
                              className="library-content-box-layuot readerlist d-flex mb-3"
                            >
                              <div className="doc-content-main-box col">
                                <h6>
                                  <strong>Name | </strong>
                                  {user.name}
                                </h6>
                                <h6>
                                  <strong>Email | </strong>
                                  {user.email}
                                </h6>
                                <h6>
                                  <strong>Type | </strong>
                                  {isInternal ? "Internal" : "External"}
                                </h6>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT PREVIEW */}
                <div className="col-12 verify-right">
                  <div className="preview_mail">
                    <h4>Preview Your Email</h4>
                    <p>
                      {emailSubject || "Welcome to the VWD Journey Platform"}
                    </p>
                    <div className="preview-wrapper">
                      <div className="preview-mail verify-preview">
                        {emailContent ? (
                          <div className="email-content-preview">
                            {templateUrl ? (
                              <img
                                src={templateUrl}
                                alt="Email Template Preview"
                                style={{ width: "100%" }}
                              />
                            ) : (
                              <div>
                                <Placeholder as="div" animation="wave">
                                  <Placeholder
                                    xs={12}
                                    style={{
                                      height: "600px",
                                      backgroundColor: "#97B6CF",
                                    }}
                                  />
                                </Placeholder>
                              </div>
                            )}
                          </div>
                        ) : (
                          <p className="text-muted">
                            No email content to preview
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
